const errors = {
  heading: "Unknown Error",
  message: "The application has encountered an unknown error.",
};

export default errors;
